import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { GroupClassification } from './hooks/useGroupClassification';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(9),
    margin: theme.spacing(0, 0, 0, 2),
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center'
  },
  label: {
    padding: theme.spacing(0, 0.75),
    color: theme.palette.grey[800],
    borderRadius: theme.spacing(0.25)
  },
  [`${GroupClassification.Unclassified}`]: {
    background: theme.palette.notesLabel.inbox
  },
  [`${GroupClassification.Private}`]: {
    background: theme.palette.notesLabel.private
  },
  [`${GroupClassification.Accepted}`]: {
    background: theme.palette.notesLabel.accepted
  },
  [`${GroupClassification.Multiple}`]: {
    background: theme.palette.notesLabel.multiple
  }
}));

type GroupClassificationTagProps = {
  groupKey: string;
  groupClassification: GroupClassification;
};

export const GroupClassificationTag: React.FC<GroupClassificationTagProps> = ({
  groupKey,
  groupClassification
}: GroupClassificationTagProps) => {
  const classes = useStyles();
  return (
    <div
      data-testid={`group-classification-tag-${groupClassification}-${groupKey}`}
      className={classes.root}
    >
      <Typography
        className={classnames(classes.label, classes[`${groupClassification}`])}
        variant="caption"
      >
        <FormattedMessage id={`notes.${groupClassification.toLowerCase()}`} />
      </Typography>
    </div>
  );
};
